import EmojiPicker, {
    EmojiClickData,
    SkinTonePickerLocation,
    Theme
} from "emoji-picker-react";
import { useDispatch, useSelector } from "react-redux";
import {
    closeEmojiodal,
    setEmoji
} from "services/redux/commentForm/commentForm";
import { addIncidentEmoji } from "services/redux/incidentForm/incidentForm";
import { addEmoji } from "services/redux/postForm/postForm";
import { AppDispatch, RootState } from "services/redux/store";
import { SVG } from "ui";
import { CustomComponentProps } from "utils/types/generalTypes";
import useWindowSize from "utils/hooks/useWindowSize";

export type EmojiModalProps = CustomComponentProps;

const EmojiModal = ({ className, style }: EmojiModalProps) => {
    const mode = useSelector((state: RootState) => state.site.mode);
    const modalPosition = useSelector(
        (state: RootState) => state.postForm.emojiModalPosition
    );
    const formType = useSelector((state: RootState) => state.feedForm.formType);
    const openEmojiModal = useSelector(
        (state: RootState) => state.commentForm.openEmoji
    );

    const dispatch = useDispatch<AppDispatch>();

    const handleSelectEmoji = (emoji: EmojiClickData) => {
        if (formType == "post") {
            dispatch(addEmoji(emoji));
        } else if (formType == "incident") {
            dispatch(addIncidentEmoji(emoji));
        } else {
            dispatch(setEmoji(emoji.emoji));
        }
    };

    const handleCloseEmoji = () => {
        // setOpen(false);
        // dispatch(closeFeedFormEmoji());
        dispatch(closeEmojiodal());
    };

    const [windowWidth] = useWindowSize();
    const makeModalStyle = (): React.CSSProperties => {
        // console.log("ok");
        if (windowWidth < 567) {
            return {
                top: `${modalPosition.top}px`
            };
        } else {
            return {
                top: `${modalPosition.top}px`,
                left: `${modalPosition.left}px`
            };
        }
    };

    return (
        <div
            id="emoji-modal"
            className={`modal emoji-modal ${openEmojiModal ? "is-active" : ""} ${className}`}
            style={{ ...style, zIndex: 99999 }}
        >
            <div className="modal-background" onClick={handleCloseEmoji}></div>
            <div className="modal-content" style={makeModalStyle()}>
                <div className="card is-new-content">
                    <div className="p-relative ">
                        <div className="close-wrap">
                            <span
                                className="custom-close-modal"
                                onClick={handleCloseEmoji}
                            >
                                <SVG svg="x" size={16} />
                            </span>
                        </div>
                        <div className="pickerContainer">
                            <EmojiPicker
                                open={true}
                                onEmojiClick={(emoji) => {
                                    handleSelectEmoji(emoji);
                                }}
                                theme={
                                    mode == "light" ? Theme.LIGHT : Theme.DARK
                                }
                                skinTonePickerLocation={
                                    SkinTonePickerLocation.PREVIEW
                                }
                                width={300}
                                height={400}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmojiModal;
